/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthedIndexRouteImport } from './routes/_authed/index'
import { Route as AuthedAuditRouteImport } from './routes/_authed/audit'
import { Route as AuthedCashierRouteImport } from './routes/_authed/cashier'
import { Route as AuthedDevicesRouteImport } from './routes/_authed/devices'
import { Route as AuthedDiscountApprovalsRouteImport } from './routes/_authed/discount-approvals'
import { Route as AuthedDiscountsRouteImport } from './routes/_authed/discounts'
import { Route as AuthedKitchenRouteImport } from './routes/_authed/kitchen'
import { Route as AuthedOfflineExceptionsRouteImport } from './routes/_authed/offline-exceptions'
import { Route as AuthedPaymentExceptionsRouteImport } from './routes/_authed/payment-exceptions'
import { Route as AuthedPaymentVerificationsRouteImport } from './routes/_authed/payment-verifications'
import { Route as AuthedRefundsRouteImport } from './routes/_authed/refunds'
import { Route as AuthedReportsRouteImport } from './routes/_authed/reports'
import { Route as AuthedSecurityRouteImport } from './routes/_authed/security'
import { Route as AuthedShiftRouteImport } from './routes/_authed/shift'
import { Route as AuthedStaffRouteImport } from './routes/_authed/staff'
import { Route as AuthedStockRouteImport } from './routes/_authed/stock'
import { Route as AuthedCatalogueIndexRouteImport } from './routes/_authed/catalogue/index'
import { Route as AuthedCatalogueProductIdRouteImport } from './routes/_authed/catalogue/$productId'
import { Route as AuthedCustomersIndexRouteImport } from './routes/_authed/customers/index'
import { Route as AuthedCustomersCustomerIdRouteImport } from './routes/_authed/customers/$customerId'
import { Route as AuthedCustomersDuplicatesRouteImport } from './routes/_authed/customers/duplicates'
import { Route as AuthedOutletsOutletIdRouteImport } from './routes/_authed/outlets/$outletId'
import { Route as AuthedSettingsIndexRouteImport } from './routes/_authed/settings/index'
import { Route as AuthedSettingsBrandRouteImport } from './routes/_authed/settings/brand'
import { Route as AuthedSettingsPaymentsRouteImport } from './routes/_authed/settings/payments'
import { Route as AuthedSettingsTaxRouteImport } from './routes/_authed/settings/tax'
import { Route as AuthedShiftsIndexRouteImport } from './routes/_authed/shifts/index'
import { Route as AuthedShiftsShiftIdRouteImport } from './routes/_authed/shifts/$shiftId'
import { Route as AuthedCatalogueModifiersGroupIdRouteImport } from './routes/_authed/catalogue/modifiers/$groupId'

const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAuditRoute = AuthedAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCashierRoute = AuthedCashierRouteImport.update({
  id: '/cashier',
  path: '/cashier',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDevicesRoute = AuthedDevicesRouteImport.update({
  id: '/devices',
  path: '/devices',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDiscountApprovalsRoute = AuthedDiscountApprovalsRouteImport.update({
  id: '/discount-approvals',
  path: '/discount-approvals',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDiscountsRoute = AuthedDiscountsRouteImport.update({
  id: '/discounts',
  path: '/discounts',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedKitchenRoute = AuthedKitchenRouteImport.update({
  id: '/kitchen',
  path: '/kitchen',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedOfflineExceptionsRoute = AuthedOfflineExceptionsRouteImport.update({
  id: '/offline-exceptions',
  path: '/offline-exceptions',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPaymentExceptionsRoute = AuthedPaymentExceptionsRouteImport.update({
  id: '/payment-exceptions',
  path: '/payment-exceptions',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPaymentVerificationsRoute =
  AuthedPaymentVerificationsRouteImport.update({
    id: '/payment-verifications',
    path: '/payment-verifications',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedRefundsRoute = AuthedRefundsRouteImport.update({
  id: '/refunds',
  path: '/refunds',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedReportsRoute = AuthedReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSecurityRoute = AuthedSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedShiftRoute = AuthedShiftRouteImport.update({
  id: '/shift',
  path: '/shift',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedStaffRoute = AuthedStaffRouteImport.update({
  id: '/staff',
  path: '/staff',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedStockRoute = AuthedStockRouteImport.update({
  id: '/stock',
  path: '/stock',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCatalogueIndexRoute = AuthedCatalogueIndexRouteImport.update({
  id: '/catalogue/',
  path: '/catalogue/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCatalogueProductIdRoute =
  AuthedCatalogueProductIdRouteImport.update({
    id: '/catalogue/$productId',
    path: '/catalogue/$productId',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedCustomersIndexRoute = AuthedCustomersIndexRouteImport.update({
  id: '/customers/',
  path: '/customers/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCustomersCustomerIdRoute =
  AuthedCustomersCustomerIdRouteImport.update({
    id: '/customers/$customerId',
    path: '/customers/$customerId',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedCustomersDuplicatesRoute =
  AuthedCustomersDuplicatesRouteImport.update({
    id: '/customers/duplicates',
    path: '/customers/duplicates',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedOutletsOutletIdRoute = AuthedOutletsOutletIdRouteImport.update({
  id: '/outlets/$outletId',
  path: '/outlets/$outletId',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSettingsIndexRoute = AuthedSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSettingsBrandRoute = AuthedSettingsBrandRouteImport.update({
  id: '/settings/brand',
  path: '/settings/brand',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSettingsPaymentsRoute = AuthedSettingsPaymentsRouteImport.update({
  id: '/settings/payments',
  path: '/settings/payments',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSettingsTaxRoute = AuthedSettingsTaxRouteImport.update({
  id: '/settings/tax',
  path: '/settings/tax',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedShiftsIndexRoute = AuthedShiftsIndexRouteImport.update({
  id: '/shifts/',
  path: '/shifts/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedShiftsShiftIdRoute = AuthedShiftsShiftIdRouteImport.update({
  id: '/shifts/$shiftId',
  path: '/shifts/$shiftId',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCatalogueModifiersGroupIdRoute =
  AuthedCatalogueModifiersGroupIdRouteImport.update({
    id: '/catalogue/modifiers/$groupId',
    path: '/catalogue/modifiers/$groupId',
    getParentRoute: () => AuthedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthedIndexRoute
  '/login': typeof LoginRoute
  '/audit': typeof AuthedAuditRoute
  '/cashier': typeof AuthedCashierRoute
  '/devices': typeof AuthedDevicesRoute
  '/discount-approvals': typeof AuthedDiscountApprovalsRoute
  '/discounts': typeof AuthedDiscountsRoute
  '/kitchen': typeof AuthedKitchenRoute
  '/offline-exceptions': typeof AuthedOfflineExceptionsRoute
  '/payment-exceptions': typeof AuthedPaymentExceptionsRoute
  '/payment-verifications': typeof AuthedPaymentVerificationsRoute
  '/refunds': typeof AuthedRefundsRoute
  '/reports': typeof AuthedReportsRoute
  '/security': typeof AuthedSecurityRoute
  '/shift': typeof AuthedShiftRoute
  '/staff': typeof AuthedStaffRoute
  '/stock': typeof AuthedStockRoute
  '/catalogue/$productId': typeof AuthedCatalogueProductIdRoute
  '/customers/$customerId': typeof AuthedCustomersCustomerIdRoute
  '/customers/duplicates': typeof AuthedCustomersDuplicatesRoute
  '/outlets/$outletId': typeof AuthedOutletsOutletIdRoute
  '/settings/brand': typeof AuthedSettingsBrandRoute
  '/settings/payments': typeof AuthedSettingsPaymentsRoute
  '/settings/tax': typeof AuthedSettingsTaxRoute
  '/shifts/$shiftId': typeof AuthedShiftsShiftIdRoute
  '/catalogue/': typeof AuthedCatalogueIndexRoute
  '/customers/': typeof AuthedCustomersIndexRoute
  '/settings/': typeof AuthedSettingsIndexRoute
  '/shifts/': typeof AuthedShiftsIndexRoute
  '/catalogue/modifiers/$groupId': typeof AuthedCatalogueModifiersGroupIdRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/audit': typeof AuthedAuditRoute
  '/cashier': typeof AuthedCashierRoute
  '/devices': typeof AuthedDevicesRoute
  '/discount-approvals': typeof AuthedDiscountApprovalsRoute
  '/discounts': typeof AuthedDiscountsRoute
  '/kitchen': typeof AuthedKitchenRoute
  '/offline-exceptions': typeof AuthedOfflineExceptionsRoute
  '/payment-exceptions': typeof AuthedPaymentExceptionsRoute
  '/payment-verifications': typeof AuthedPaymentVerificationsRoute
  '/refunds': typeof AuthedRefundsRoute
  '/reports': typeof AuthedReportsRoute
  '/security': typeof AuthedSecurityRoute
  '/shift': typeof AuthedShiftRoute
  '/staff': typeof AuthedStaffRoute
  '/stock': typeof AuthedStockRoute
  '/': typeof AuthedIndexRoute
  '/catalogue/$productId': typeof AuthedCatalogueProductIdRoute
  '/customers/$customerId': typeof AuthedCustomersCustomerIdRoute
  '/customers/duplicates': typeof AuthedCustomersDuplicatesRoute
  '/outlets/$outletId': typeof AuthedOutletsOutletIdRoute
  '/settings/brand': typeof AuthedSettingsBrandRoute
  '/settings/payments': typeof AuthedSettingsPaymentsRoute
  '/settings/tax': typeof AuthedSettingsTaxRoute
  '/shifts/$shiftId': typeof AuthedShiftsShiftIdRoute
  '/catalogue': typeof AuthedCatalogueIndexRoute
  '/customers': typeof AuthedCustomersIndexRoute
  '/settings': typeof AuthedSettingsIndexRoute
  '/shifts': typeof AuthedShiftsIndexRoute
  '/catalogue/modifiers/$groupId': typeof AuthedCatalogueModifiersGroupIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authed': typeof AuthedRouteWithChildren
  '/login': typeof LoginRoute
  '/_authed/audit': typeof AuthedAuditRoute
  '/_authed/cashier': typeof AuthedCashierRoute
  '/_authed/devices': typeof AuthedDevicesRoute
  '/_authed/discount-approvals': typeof AuthedDiscountApprovalsRoute
  '/_authed/discounts': typeof AuthedDiscountsRoute
  '/_authed/kitchen': typeof AuthedKitchenRoute
  '/_authed/offline-exceptions': typeof AuthedOfflineExceptionsRoute
  '/_authed/payment-exceptions': typeof AuthedPaymentExceptionsRoute
  '/_authed/payment-verifications': typeof AuthedPaymentVerificationsRoute
  '/_authed/refunds': typeof AuthedRefundsRoute
  '/_authed/reports': typeof AuthedReportsRoute
  '/_authed/security': typeof AuthedSecurityRoute
  '/_authed/shift': typeof AuthedShiftRoute
  '/_authed/staff': typeof AuthedStaffRoute
  '/_authed/stock': typeof AuthedStockRoute
  '/_authed/': typeof AuthedIndexRoute
  '/_authed/catalogue/$productId': typeof AuthedCatalogueProductIdRoute
  '/_authed/customers/$customerId': typeof AuthedCustomersCustomerIdRoute
  '/_authed/customers/duplicates': typeof AuthedCustomersDuplicatesRoute
  '/_authed/outlets/$outletId': typeof AuthedOutletsOutletIdRoute
  '/_authed/settings/brand': typeof AuthedSettingsBrandRoute
  '/_authed/settings/payments': typeof AuthedSettingsPaymentsRoute
  '/_authed/settings/tax': typeof AuthedSettingsTaxRoute
  '/_authed/shifts/$shiftId': typeof AuthedShiftsShiftIdRoute
  '/_authed/catalogue/': typeof AuthedCatalogueIndexRoute
  '/_authed/customers/': typeof AuthedCustomersIndexRoute
  '/_authed/settings/': typeof AuthedSettingsIndexRoute
  '/_authed/shifts/': typeof AuthedShiftsIndexRoute
  '/_authed/catalogue/modifiers/$groupId': typeof AuthedCatalogueModifiersGroupIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/audit'
    | '/cashier'
    | '/devices'
    | '/discount-approvals'
    | '/discounts'
    | '/kitchen'
    | '/offline-exceptions'
    | '/payment-exceptions'
    | '/payment-verifications'
    | '/refunds'
    | '/reports'
    | '/security'
    | '/shift'
    | '/staff'
    | '/stock'
    | '/catalogue/$productId'
    | '/customers/$customerId'
    | '/customers/duplicates'
    | '/outlets/$outletId'
    | '/settings/brand'
    | '/settings/payments'
    | '/settings/tax'
    | '/shifts/$shiftId'
    | '/catalogue/'
    | '/customers/'
    | '/settings/'
    | '/shifts/'
    | '/catalogue/modifiers/$groupId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/audit'
    | '/cashier'
    | '/devices'
    | '/discount-approvals'
    | '/discounts'
    | '/kitchen'
    | '/offline-exceptions'
    | '/payment-exceptions'
    | '/payment-verifications'
    | '/refunds'
    | '/reports'
    | '/security'
    | '/shift'
    | '/staff'
    | '/stock'
    | '/'
    | '/catalogue/$productId'
    | '/customers/$customerId'
    | '/customers/duplicates'
    | '/outlets/$outletId'
    | '/settings/brand'
    | '/settings/payments'
    | '/settings/tax'
    | '/shifts/$shiftId'
    | '/catalogue'
    | '/customers'
    | '/settings'
    | '/shifts'
    | '/catalogue/modifiers/$groupId'
  id:
    | '__root__'
    | '/_authed'
    | '/login'
    | '/_authed/audit'
    | '/_authed/cashier'
    | '/_authed/devices'
    | '/_authed/discount-approvals'
    | '/_authed/discounts'
    | '/_authed/kitchen'
    | '/_authed/offline-exceptions'
    | '/_authed/payment-exceptions'
    | '/_authed/payment-verifications'
    | '/_authed/refunds'
    | '/_authed/reports'
    | '/_authed/security'
    | '/_authed/shift'
    | '/_authed/staff'
    | '/_authed/stock'
    | '/_authed/'
    | '/_authed/catalogue/$productId'
    | '/_authed/customers/$customerId'
    | '/_authed/customers/duplicates'
    | '/_authed/outlets/$outletId'
    | '/_authed/settings/brand'
    | '/_authed/settings/payments'
    | '/_authed/settings/tax'
    | '/_authed/shifts/$shiftId'
    | '/_authed/catalogue/'
    | '/_authed/customers/'
    | '/_authed/settings/'
    | '/_authed/shifts/'
    | '/_authed/catalogue/modifiers/$groupId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRoute: typeof AuthedRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/': {
      id: '/_authed/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/audit': {
      id: '/_authed/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AuthedAuditRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/cashier': {
      id: '/_authed/cashier'
      path: '/cashier'
      fullPath: '/cashier'
      preLoaderRoute: typeof AuthedCashierRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/devices': {
      id: '/_authed/devices'
      path: '/devices'
      fullPath: '/devices'
      preLoaderRoute: typeof AuthedDevicesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/discount-approvals': {
      id: '/_authed/discount-approvals'
      path: '/discount-approvals'
      fullPath: '/discount-approvals'
      preLoaderRoute: typeof AuthedDiscountApprovalsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/discounts': {
      id: '/_authed/discounts'
      path: '/discounts'
      fullPath: '/discounts'
      preLoaderRoute: typeof AuthedDiscountsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/kitchen': {
      id: '/_authed/kitchen'
      path: '/kitchen'
      fullPath: '/kitchen'
      preLoaderRoute: typeof AuthedKitchenRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/offline-exceptions': {
      id: '/_authed/offline-exceptions'
      path: '/offline-exceptions'
      fullPath: '/offline-exceptions'
      preLoaderRoute: typeof AuthedOfflineExceptionsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/payment-exceptions': {
      id: '/_authed/payment-exceptions'
      path: '/payment-exceptions'
      fullPath: '/payment-exceptions'
      preLoaderRoute: typeof AuthedPaymentExceptionsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/payment-verifications': {
      id: '/_authed/payment-verifications'
      path: '/payment-verifications'
      fullPath: '/payment-verifications'
      preLoaderRoute: typeof AuthedPaymentVerificationsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/refunds': {
      id: '/_authed/refunds'
      path: '/refunds'
      fullPath: '/refunds'
      preLoaderRoute: typeof AuthedRefundsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/reports': {
      id: '/_authed/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AuthedReportsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/security': {
      id: '/_authed/security'
      path: '/security'
      fullPath: '/security'
      preLoaderRoute: typeof AuthedSecurityRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/shift': {
      id: '/_authed/shift'
      path: '/shift'
      fullPath: '/shift'
      preLoaderRoute: typeof AuthedShiftRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/staff': {
      id: '/_authed/staff'
      path: '/staff'
      fullPath: '/staff'
      preLoaderRoute: typeof AuthedStaffRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/stock': {
      id: '/_authed/stock'
      path: '/stock'
      fullPath: '/stock'
      preLoaderRoute: typeof AuthedStockRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/catalogue/': {
      id: '/_authed/catalogue/'
      path: '/catalogue'
      fullPath: '/catalogue/'
      preLoaderRoute: typeof AuthedCatalogueIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/catalogue/$productId': {
      id: '/_authed/catalogue/$productId'
      path: '/catalogue/$productId'
      fullPath: '/catalogue/$productId'
      preLoaderRoute: typeof AuthedCatalogueProductIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/customers/': {
      id: '/_authed/customers/'
      path: '/customers'
      fullPath: '/customers/'
      preLoaderRoute: typeof AuthedCustomersIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/customers/$customerId': {
      id: '/_authed/customers/$customerId'
      path: '/customers/$customerId'
      fullPath: '/customers/$customerId'
      preLoaderRoute: typeof AuthedCustomersCustomerIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/customers/duplicates': {
      id: '/_authed/customers/duplicates'
      path: '/customers/duplicates'
      fullPath: '/customers/duplicates'
      preLoaderRoute: typeof AuthedCustomersDuplicatesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/outlets/$outletId': {
      id: '/_authed/outlets/$outletId'
      path: '/outlets/$outletId'
      fullPath: '/outlets/$outletId'
      preLoaderRoute: typeof AuthedOutletsOutletIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings/': {
      id: '/_authed/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthedSettingsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings/brand': {
      id: '/_authed/settings/brand'
      path: '/settings/brand'
      fullPath: '/settings/brand'
      preLoaderRoute: typeof AuthedSettingsBrandRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings/payments': {
      id: '/_authed/settings/payments'
      path: '/settings/payments'
      fullPath: '/settings/payments'
      preLoaderRoute: typeof AuthedSettingsPaymentsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings/tax': {
      id: '/_authed/settings/tax'
      path: '/settings/tax'
      fullPath: '/settings/tax'
      preLoaderRoute: typeof AuthedSettingsTaxRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/shifts/': {
      id: '/_authed/shifts/'
      path: '/shifts'
      fullPath: '/shifts/'
      preLoaderRoute: typeof AuthedShiftsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/shifts/$shiftId': {
      id: '/_authed/shifts/$shiftId'
      path: '/shifts/$shiftId'
      fullPath: '/shifts/$shiftId'
      preLoaderRoute: typeof AuthedShiftsShiftIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/catalogue/modifiers/$groupId': {
      id: '/_authed/catalogue/modifiers/$groupId'
      path: '/catalogue/modifiers/$groupId'
      fullPath: '/catalogue/modifiers/$groupId'
      preLoaderRoute: typeof AuthedCatalogueModifiersGroupIdRouteImport
      parentRoute: typeof AuthedRoute
    }
  }
}

interface AuthedRouteChildren {
  AuthedAuditRoute: typeof AuthedAuditRoute
  AuthedCashierRoute: typeof AuthedCashierRoute
  AuthedDevicesRoute: typeof AuthedDevicesRoute
  AuthedDiscountApprovalsRoute: typeof AuthedDiscountApprovalsRoute
  AuthedDiscountsRoute: typeof AuthedDiscountsRoute
  AuthedKitchenRoute: typeof AuthedKitchenRoute
  AuthedOfflineExceptionsRoute: typeof AuthedOfflineExceptionsRoute
  AuthedPaymentExceptionsRoute: typeof AuthedPaymentExceptionsRoute
  AuthedPaymentVerificationsRoute: typeof AuthedPaymentVerificationsRoute
  AuthedRefundsRoute: typeof AuthedRefundsRoute
  AuthedReportsRoute: typeof AuthedReportsRoute
  AuthedSecurityRoute: typeof AuthedSecurityRoute
  AuthedShiftRoute: typeof AuthedShiftRoute
  AuthedStaffRoute: typeof AuthedStaffRoute
  AuthedStockRoute: typeof AuthedStockRoute
  AuthedIndexRoute: typeof AuthedIndexRoute
  AuthedCatalogueProductIdRoute: typeof AuthedCatalogueProductIdRoute
  AuthedCustomersCustomerIdRoute: typeof AuthedCustomersCustomerIdRoute
  AuthedCustomersDuplicatesRoute: typeof AuthedCustomersDuplicatesRoute
  AuthedOutletsOutletIdRoute: typeof AuthedOutletsOutletIdRoute
  AuthedSettingsBrandRoute: typeof AuthedSettingsBrandRoute
  AuthedSettingsPaymentsRoute: typeof AuthedSettingsPaymentsRoute
  AuthedSettingsTaxRoute: typeof AuthedSettingsTaxRoute
  AuthedShiftsShiftIdRoute: typeof AuthedShiftsShiftIdRoute
  AuthedCatalogueIndexRoute: typeof AuthedCatalogueIndexRoute
  AuthedCustomersIndexRoute: typeof AuthedCustomersIndexRoute
  AuthedSettingsIndexRoute: typeof AuthedSettingsIndexRoute
  AuthedShiftsIndexRoute: typeof AuthedShiftsIndexRoute
  AuthedCatalogueModifiersGroupIdRoute: typeof AuthedCatalogueModifiersGroupIdRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedAuditRoute: AuthedAuditRoute,
  AuthedCashierRoute: AuthedCashierRoute,
  AuthedDevicesRoute: AuthedDevicesRoute,
  AuthedDiscountApprovalsRoute: AuthedDiscountApprovalsRoute,
  AuthedDiscountsRoute: AuthedDiscountsRoute,
  AuthedKitchenRoute: AuthedKitchenRoute,
  AuthedOfflineExceptionsRoute: AuthedOfflineExceptionsRoute,
  AuthedPaymentExceptionsRoute: AuthedPaymentExceptionsRoute,
  AuthedPaymentVerificationsRoute: AuthedPaymentVerificationsRoute,
  AuthedRefundsRoute: AuthedRefundsRoute,
  AuthedReportsRoute: AuthedReportsRoute,
  AuthedSecurityRoute: AuthedSecurityRoute,
  AuthedShiftRoute: AuthedShiftRoute,
  AuthedStaffRoute: AuthedStaffRoute,
  AuthedStockRoute: AuthedStockRoute,
  AuthedIndexRoute: AuthedIndexRoute,
  AuthedCatalogueProductIdRoute: AuthedCatalogueProductIdRoute,
  AuthedCustomersCustomerIdRoute: AuthedCustomersCustomerIdRoute,
  AuthedCustomersDuplicatesRoute: AuthedCustomersDuplicatesRoute,
  AuthedOutletsOutletIdRoute: AuthedOutletsOutletIdRoute,
  AuthedSettingsBrandRoute: AuthedSettingsBrandRoute,
  AuthedSettingsPaymentsRoute: AuthedSettingsPaymentsRoute,
  AuthedSettingsTaxRoute: AuthedSettingsTaxRoute,
  AuthedShiftsShiftIdRoute: AuthedShiftsShiftIdRoute,
  AuthedCatalogueIndexRoute: AuthedCatalogueIndexRoute,
  AuthedCustomersIndexRoute: AuthedCustomersIndexRoute,
  AuthedSettingsIndexRoute: AuthedSettingsIndexRoute,
  AuthedShiftsIndexRoute: AuthedShiftsIndexRoute,
  AuthedCatalogueModifiersGroupIdRoute: AuthedCatalogueModifiersGroupIdRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthedRoute: AuthedRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
